<div class="bg-white/90 rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
  <div class="px-4 py-3 border-b bg-white">
    <div class="text-center text-xs tracking-[0.2em] text-gray-600 font-semibold">PERSONAL DETAILS</div>
  </div>

  <div class="p-4 space-y-4">
    <!-- Date of birth -->
    <div>
      <div class="text-xs font-semibold mb-1">Date of birth</div>
      <div class="flex items-center gap-2">
        <input class="flex-1 w-full border rounded-lg px-3 py-2 text-sm" placeholder="DD/MM/YYYY" [(ngModel)]="profile.dateOfBirth" [readonly]="!editing.dob" />
      </div>
    </div>

    <!-- Height -->
    <div>
      <div class="text-xs font-semibold mb-1">Height in {{userUnits.lengthMetric? 'cm' : 'inches'}}</div>
      <div class="flex items-center gap-2">
        <input class="flex-1 w-full border rounded-lg px-3 py-2 text-sm" placeholder="165 cm" [(ngModel)]="profile.heightInCm" [readonly]="!editing.height" />
      </div>
    </div>

    <!-- Weight -->
    <div>
      <div class="text-xs font-semibold mb-1">Weight in {{userUnits.massMetric? 'kg' : 'lbs'}}</div>
      <div class="flex items-center gap-2">
        <input class="flex-1 w-full border rounded-lg px-3 py-2 text-sm" placeholder="56.60 kg" [(ngModel)]="profile.weightInKg" [readonly]="!editing.weight" />
      </div>
    </div>

    <div class="pt-2">
      <button class="w-full bg-purple-600 text-white rounded-lg py-2 text-sm" (click)="save()">Save</button>
    </div>
  </div>
</div>

<div class="mt-4 bg-white/90 rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
  <div class="px-4 py-3 border-b bg-white">
    <div class="text-center text-xs tracking-[0.2em] text-gray-600 font-semibold">UNITS</div>
  </div>
  <div class="p-2 divide-y">
    <div class="flex items-center justify-between py-3">
      <div class="text-xs font-semibold">Weight</div>
      <div class="flex gap-2">
        <button class="px-3 py-1 rounded-md text-xs" [class.bg-black]="userUnits?.massMetric" [class.text-white]="userUnits?.massMetric" (click)="setUnit('massMetric', true)">kg</button>
        <button class="px-3 py-1 rounded-md text-xs" [class.bg-black]="userUnits && !userUnits.massMetric" [class.text-white]="userUnits && !userUnits.massMetric" (click)="setUnit('massMetric', false)">lbs</button>
      </div>
    </div>
    <div class="flex items-center justify-between py-3">
      <div class="text-xs font-semibold">Length</div>
      <div class="flex gap-2">
        <button class="px-3 py-1 rounded-md text-xs" [class.bg-black]="userUnits?.lengthMetric" [class.text-white]="userUnits?.lengthMetric" (click)="setUnit('lengthMetric', true)">metric</button>
        <button class="px-3 py-1 rounded-md text-xs" [class.bg-black]="userUnits && !userUnits.lengthMetric" [class.text-white]="userUnits && !userUnits.lengthMetric" (click)="setUnit('lengthMetric', false)">imperial</button>
      </div>
    </div>
    <div class="flex items-center justify-between py-3">
      <div class="text-xs font-semibold">Temperature</div>
      <div class="flex gap-2">
        <button class="px-3 py-1 rounded-md text-xs" [class.bg-black]="userUnits?.temperatureCelsius" [class.text-white]="userUnits?.temperatureCelsius" (click)="setUnit('temperatureCelsius', true)">C</button>
        <button class="px-3 py-1 rounded-md text-xs" [class.bg-black]="userUnits && !userUnits.temperatureCelsius" [class.text-white]="userUnits && !userUnits.temperatureCelsius" (click)="setUnit('temperatureCelsius', false)">F</button>
      </div>
    </div>
    <div class="flex items-center justify-between py-3">
      <div class="text-xs font-semibold">Water intake</div>
      <div class="flex gap-2">
        <button class="px-3 py-1 rounded-md text-xs" [class.bg-black]="userUnits?.volumeMetric" [class.text-white]="userUnits?.volumeMetric" (click)="setUnit('volumeMetric', true)">liter</button>
        <button class="px-3 py-1 rounded-md text-xs" [class.bg-black]="userUnits && !userUnits.volumeMetric" [class.text-white]="userUnits && !userUnits.volumeMetric" (click)="setUnit('volumeMetric', false)">oz</button>
      </div>
    </div>
  </div>
</div>
